<toast-notification #toastNotification></toast-notification>

<div class="acs-toolbar-scroll">
  <div class="acs-toolbar">
    <div class="acs-flex acs-flex--center acs-gap-sm">
      <div class="acs-toolbar__field">
        <i class="fa-solid fa-search acs-toolbar__icon"></i>
        <input type="text" class="acs-input acs-toolbar__input"
               placeholder="Location name..."
               [(ngModel)]="locationFilter" (keyup.enter)="loadNotes()">
      </div>
      <div class="acs-toolbar__field">
        <i class="fa-solid fa-city acs-toolbar__icon"></i>
        <input type="text" class="acs-input acs-toolbar__input"
               placeholder="City..."
               [(ngModel)]="cityFilter" (keyup.enter)="loadNotes()">
      </div>
      <div class="acs-toolbar__field">
        <i class="fa-solid fa-map acs-toolbar__icon"></i>
        <input type="text" class="acs-input acs-toolbar__input"
               placeholder="State..."
               [(ngModel)]="stateFilter" (keyup.enter)="loadNotes()">
      </div>
      <button type="button" class="acs-action-btn" (click)="loadNotes()">
        <i class="fa-solid fa-search"></i>
      </button>
    </div>
    <div class="acs-flex acs-flex--center acs-gap-sm">
      <small *ngIf="locationNotes.length > 0" class="acs-text-muted">{{locationNotes.length}} note(s)</small>
      <button type="button" class="acs-action-btn acs-action-btn--danger"
              [disabled]="bulkDelete.selectedCount === 0"
              (click)="bulkDelete.requestDelete()">
        <i class="fa-solid fa-trash"></i> Delete<span *ngIf="bulkDelete.selectedCount > 0"> ({{bulkDelete.selectedCount}})</span>
      </button>
      <button type="button" class="acs-action-btn acs-action-btn--accent" (click)="addNote()">
        <i class="fa-solid fa-plus"></i> Add Note
      </button>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="!hasSearched" class="acs-table-wrap--connected acs-empty-state-wrap">
    <div class="acs-empty-state">
      <i class="fa-solid fa-sticky-note"></i>
      Search to view notes
    </div>
  </div>

  <div *ngIf="hasSearched" class="acs-table-wrap acs-table-wrap--connected acs-table--contained">
    <table class="acs-table acs-table--striped acs-table--hover acs-table--bordered">
      <thead class="acs-thead--primary acs-sticky">
        <tr>
          <th class="acs-table__checkbox-col">
            <input type="checkbox" class="acs-table__checkbox"
                   [checked]="bulkDelete.allVisibleSelected && locationNotes.length > 0"
                   (change)="bulkDelete.toggleSelectAll()">
          </th>
          <th>Loc Code</th>
          <th>Location Name</th>
          <th>City, State</th>
          <th>Updated By</th>
          <th>Updated Date</th>
          <th>Origin Notes</th>
          <th>Dest Notes</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of locationNotes"
            (click)="selectNote(item)"
            class="acs-cursor-pointer">
          <td class="acs-table__checkbox-col" (click)="$event.stopPropagation()">
            <input type="checkbox" class="acs-table__checkbox"
                   [checked]="bulkDelete.isSelected(item.locationNotesId)"
                   (change)="bulkDelete.toggle(item.locationNotesId, $event)">
          </td>
          <td>{{item.locCode}}</td>
          <td>{{item.locationName}}</td>
          <td>{{item.city}}<span *ngIf="item.province">, {{item.province}}</span></td>
          <td class="acs-small">{{item.updatedBy || item.createdBy}}</td>
          <td class="acs-small">{{(item.updatedDate || item.createdDate) | date:'M/d/yyyy h:mm a'}}</td>
          <td class="loc-notes-cell" [title]="item.originNotes || ''">{{item.originNotes}}</td>
          <td class="loc-notes-cell" [title]="item.destNotes || ''">{{item.destNotes}}</td>
        </tr>
        <tr *ngIf="locationNotes.length === 0">
          <td colspan="8" class="acs-text-center acs-text-muted">No notes found.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Add/Edit Modal -->
<div *ngIf="showDialog" class="acs-modal" tabindex="-1">
  <div class="acs-modal__dialog">
    <div class="acs-modal__content">
      <div class="acs-modal__header">
        <h6 class="acs-modal__title">{{isEditing ? 'Edit' : 'Add'}} Note</h6>
        <button type="button" class="acs-btn--close" (click)="closeDialog()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="acs-modal__body">
        <!-- Location search (Add mode only, before location is selected) -->
        <div *ngIf="!isEditing && !formLocationId" class="acs-mb-3">
          <label class="acs-label">Find Location</label>
          <div class="acs-flex acs-gap-sm">
            <input type="text" class="acs-input acs-flex-1" placeholder="Location name..."
                   [(ngModel)]="locationSearchName" (keyup.enter)="searchLocations()">
            <input type="text" class="acs-input acs-flex-1" placeholder="City..."
                   [(ngModel)]="locationSearchCity" (keyup.enter)="searchLocations()">
            <input type="text" class="acs-input acs-flex-1" placeholder="State..."
                   [(ngModel)]="locationSearchState" (keyup.enter)="searchLocations()">
            <button class="acs-btn acs-btn--primary" (click)="searchLocations()">
              <i class="fa-solid fa-search"></i>
            </button>
          </div>
          <div *ngIf="locationSearchResults.length > 0" class="loc-notes-search-results">
            <table class="acs-table acs-table--hover acs-table--bordered">
              <thead class="acs-thead--primary">
                <tr>
                  <th>Location</th>
                  <th>City, State</th>
                  <th style="width: 60px;"></th>
                </tr>
                <tr class="acs-filter-row">
                  <th>
                    <input type="text" class="acs-input acs-input--sm" placeholder="Filter location..."
                           [(ngModel)]="locationResultNameFilter">
                  </th>
                  <th>
                    <input type="text" class="acs-input acs-input--sm" placeholder="Filter city/state..."
                           [(ngModel)]="locationResultCityStateFilter">
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let loc of filteredLocationResults">
                  <td class="acs-small">{{loc.locationName}}</td>
                  <td class="acs-small">{{loc.city}}<span *ngIf="loc.state">, {{loc.state}}</span></td>
                  <td>
                    <button class="acs-btn acs-btn--outline-primary" (click)="selectLocation(loc)">Select</button>
                  </td>
                </tr>
                <tr *ngIf="filteredLocationResults.length === 0">
                  <td colspan="3" class="acs-text-center acs-text-muted acs-small">No results match your filter.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="locationSearchResults.length === 0 && locationSearched" class="acs-text-muted acs-small acs-mt-1">
            No locations found. Try a different search.
          </div>
        </div>

        <!-- Selected location display (Add mode, after selection) -->
        <div *ngIf="!isEditing && formLocationId" class="acs-mb-3">
          <label class="acs-label">Location</label>
          <div class="loc-notes-selected">
            <strong>{{formLocationName}}</strong> — {{formCity}}<span *ngIf="formProvince">, {{formProvince}}</span>
            <button class="acs-btn acs-btn--outline-primary" style="margin-left: 0.5rem; font-size: 0.7rem; padding: 0.1rem 0.35rem;"
                    (click)="clearSelectedLocation()">Change</button>
          </div>
        </div>

        <!-- Location info (Edit mode — read-only) -->
        <div *ngIf="isEditing" class="acs-mb-3">
          <label class="acs-label">Location</label>
          <div class="loc-notes-selected">
            <strong>{{formLocationName}}</strong> — {{formCity}}<span *ngIf="formProvince">, {{formProvince}}</span>
            &nbsp; <span class="acs-text-muted">({{formLocCode}})</span>
          </div>
        </div>

        <!-- Trade Unit (Add mode only) -->
        <div *ngIf="!isEditing" class="acs-mb-2">
          <label class="acs-label">Trade Unit</label>
          <div class="acs-dropdown" (click)="$event.stopPropagation()">
            <button type="button" class="acs-dropdown__trigger" (click)="formLocDropdown.toggle()"
                    [class.acs-dropdown__trigger--placeholder]="!formLocDropdown.selectedValue">
              {{formLocDropdown.displayText}}
              <i class="fa-solid fa-chevron-down acs-dropdown__arrow"></i>
            </button>
            <div class="acs-dropdown__panel" *ngIf="formLocDropdown.isOpen()">
              <input class="acs-dropdown__search" type="text" placeholder="Search..."
                     [ngModel]="formLocDropdown.searchText()" (ngModelChange)="formLocDropdown.searchText.set($event)"
                     (click)="$event.stopPropagation()" />
              <div class="acs-dropdown__options">
                <div class="acs-dropdown__option acs-dropdown__option--placeholder"
                     (click)="selectFormLoc(null)">-- Select --</div>
                <div *ngFor="let loc of formLocDropdown.filtered"
                     class="acs-dropdown__option"
                     [class.acs-dropdown__option--selected]="loc.value === formLocDropdown.selectedValue"
                     (click)="selectFormLoc(loc)">{{loc.text}}</div>
                <div *ngIf="formLocDropdown.filtered.length === 0" class="acs-dropdown__empty">No matches</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Notes -->
        <div class="acs-row acs-mb-2">
          <div class="acs-col--md6">
            <label class="acs-label">Origin Notes</label>
            <textarea class="acs-textarea" rows="4" [(ngModel)]="formOriginNotes"></textarea>
          </div>
          <div class="acs-col--md6">
            <label class="acs-label">Dest Notes</label>
            <textarea class="acs-textarea" rows="4" [(ngModel)]="formDestNotes"></textarea>
          </div>
        </div>
      </div>
      <div class="acs-modal__footer">
        <button class="acs-btn acs-btn--secondary" (click)="closeDialog()">Cancel</button>
        <button class="acs-btn acs-btn--primary" (click)="saveNote()"
                [disabled]="!isEditing && (!formLocationId || !formLocCode)">
          {{isEditing ? 'Update' : 'Save'}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Bulk Delete Confirmation Dialog -->
<div *ngIf="bulkDelete.showConfirm" class="acs-modal" tabindex="-1">
  <div class="acs-modal__dialog acs-modal__dialog--sm">
    <div class="acs-modal__content">
      <div class="acs-modal__header">
        <h6 class="acs-modal__title">Confirm Delete</h6>
        <button type="button" class="acs-btn--close" (click)="bulkDelete.cancelDelete()" [disabled]="bulkDelete.isDeleting">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="acs-modal__body">
        <p>Delete <strong>{{bulkDelete.selectedCount}}</strong> location note(s)? This action cannot be undone.</p>
      </div>
      <div class="acs-modal__footer">
        <button class="acs-btn acs-btn--secondary" (click)="bulkDelete.cancelDelete()" [disabled]="bulkDelete.isDeleting">Cancel</button>
        <button class="acs-btn acs-btn--danger" (click)="confirmBulkDelete()" [disabled]="bulkDelete.isDeleting">
          {{bulkDelete.isDeleting ? 'Deleting...' : 'Yes, Delete'}}
        </button>
      </div>
    </div>
  </div>
</div>

